import axiosInstance from "./axiosInstance";

const csrLeadsService = {
  getAccess: async () => {
    const res = await axiosInstance.get("/admin/csr-leads/access");
    return res.data;
  },

  getStats: async (params = {}) => {
    const res = await axiosInstance.get("/admin/csr-leads/stats", { params });
    return res.data;
  },

  listLeads: async (params = {}) => {
    const res = await axiosInstance.get("/admin/csr-leads/leads", { params });
    return res.data;
  },

  createLead: async (payload) => {
    const res = await axiosInstance.post("/admin/csr-leads/leads", payload);
    return res.data;
  },

  updateLead: async (id, payload) => {
    const res = await axiosInstance.put(`/admin/csr-leads/leads/${id}`, payload);
    return res.data;
  },

  deleteLead: async (id) => {
    const res = await axiosInstance.delete(`/admin/csr-leads/leads/${id}`);
    return res.data;
  },

  listAttributedUsers: async (params = {}) => {
    const res = await axiosInstance.get("/admin/csr-leads/attributed-users", { params });
    return res.data;
  },
};

export default csrLeadsService;
